<div class="human-text-cloud">
  <div [style]="{ bottom: bottom }" class="image">
    <img alt="human" src="../../../../assets/img/human-v2.png" />
  </div>
  <div *ngIf="text" [innerHTML]="text | marked" class="text"></div>
</div>

<div *ngIf="showEndDateButtons" class="buttons">
  <button
    (click)="
      gameService.showEndDatePicker.next(!gameService.showEndDatePicker.value);
      this.gameService.turnOffEndDateRequest();
      gameService.toggleSecondDayEndRequest()
    "
    class="blue"
  >
    <div></div>
    Vul in <img alt="arrow right" src="../../../../assets/icons/white-arrow-button-right.svg" />
  </button>
  <button (click)="gameService.turnOffEndDateRequest(); gameService?.turnOnShowWelcome(); gameService.toggleSecondDayEndRequest()">
    <div></div>
    Nog niet <img alt="arrow right" src="../../../../assets/icons/grey-arrow-button-right.svg" />
  </button>
</div>

<div *ngIf="showGoToMissionsButton" class="buttons">
  <button (click)="gameService.turnOffShowWelcome()" class="blue">
    <div></div>
    Verder <img alt="arrow right" src="../../../../assets/icons/white-arrow-button-right.svg" />
  </button>
</div>

<div *ngIf="showFeedbackButton" class="buttons">
  <button (click)="feedbackService.showFeedbackModal.next(true)" class="blue" style="padding: 5px 10px">
    {{ feedbackButtonText ?? 'Feedback' }}
  </button>
  <button (click)="gameService.turnOffShowWelcome()" style="padding: 5px 10px">
    <div></div>
    Niet nu
  </button>
</div>
